/**
 * Language Switcher Component
 * Allows switching between EN/LT/BE
 */

import React from 'react';
import styles from './LanguageSwitcher.module.css';

export type Language = 'en' | 'lt' | 'be';

interface LanguageSwitcherProps {
  currentLang: Language;
  onLanguageChange: (lang: Language) => void;
}

const LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'lt', label: 'LT', flag: '🇱🇹' },
  { code: 'be', label: 'BE', flag: '🇧🇾' },
];

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  currentLang,
  onLanguageChange,
}) => {
  return (
    <div
      className={styles.langSwitcher}
      role="group"
      aria-label="Language selection"
    >
      {LANGUAGES.map(({ code, label, flag }) => (
        <button
          key={code}
          className={`${styles.langBtn} ${currentLang === code ? styles.active : ''}`}
          aria-pressed={currentLang === code}
          onClick={() => onLanguageChange(code)}
        >
          {flag} {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
